var React = require('react');

function ArrowLeftLong (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M400-240 160-480l240-240 56 58-142 142h486v80H314l142 142-56 58Z"}));
}

ArrowLeftLong.defaultProps = {"fill":"currentColor","height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = ArrowLeftLong;

ArrowLeftLong.default = ArrowLeftLong;
